export const environment = {
  production: true,
  nom: '',
  annuaire_api: 'https://annuaire.seculib.fr',
};
